/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBritaxBuyboxSwatchesViewProps } from './britax-buybox-swatches';

export default (props: IBritaxBuyboxSwatchesViewProps) => {
    return <div>{props.swatches}</div>;
};
